// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"style_breadcrumbs__2P4ha","current":"style_current__2-UXe","arrow":"style_arrow__9oq_H"};